/**
 * Toaster container logic selectors
 *
 * @author Rafael Guedes <rguedes@ubiwhere.com>
 *
 */

import { RootState } from 'store/rootSlices';

export const getToasterSlice = (state: RootState) => state.Toaster;
